import { z } from "zod";
import { LayoutTree } from "./layout";
import { TaskView } from "./views";

export const DASHBOARD_SCHEMA_VERSION = 1;

/** Widget configuration, validated by `paneType`. Panes in a dashboard layout use these. */
export const WidgetConfig = z.discriminatedUnion("widget", [
  z.object({ widget: z.literal("tasks.today") }),
  z.object({ widget: z.literal("tasks.overdue") }),
  z.object({ widget: z.literal("tasks.upcoming"), days: z.number().int().positive().default(7) }),
  z.object({ widget: z.literal("tasks.byProject"), projectId: z.string() }),
  z.object({ widget: z.literal("tasks.completedThisWeek") }),
  z.object({ widget: z.literal("tasks.view"), view: TaskView }),
  z.object({ widget: z.literal("notes.recent"), limit: z.number().int().positive().default(10) }),
  z.object({ widget: z.literal("notes.pinned") }),
  z.object({
    widget: z.literal("calendar.upcoming"),
    hours: z.number().int().positive().default(24),
  }),
  z.object({ widget: z.literal("calendar.week") }),
]);
export type WidgetConfig = z.infer<typeof WidgetConfig>;

export const DashboardConfig = z.object({
  version: z.literal(DASHBOARD_SCHEMA_VERSION),
  id: z.string(),
  name: z.string(),
  layout: LayoutTree,
  calendarSetId: z.string().optional(),
});
export type DashboardConfig = z.infer<typeof DashboardConfig>;
